export const DropDownMinFilterLimit = 7;